<template>
  <div :class="$style['pt-life-experience-pavilion-form']" v-loading="detail_loading">
    <pt-life-experience-pavilion-with-data :isEdit="isEdit" :userLogin="userLogin" ref="form" @submitLoading="submitLoading"
      @detailLoading="detailLoading"></pt-life-experience-pavilion-with-data>
    <div>
      <el-button type="primary" @click="submit" :loading="loading">确认</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import PtLifeExperiencePavilionWithData from './withData'
// 组件class前缀
export default {
  name: 'pt-life-experience-pavilion-form',
  components: {
    PtLifeExperiencePavilionWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      detail_loading: false
    }
  },
  methods: {
    detailLoading (val) {
      this.detail_loading = val
    },
    submitLoading (val) {
      this.loading = val
    },
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */

</style>
